export const getCurrentTimeHHMM = () => {
  const now = new Date();
  const currentHour = now.getHours().toString().padStart(2, "0");
  const currentMinutes = now.getMinutes().toString().padStart(2, "0");
  return `${currentHour}:${currentMinutes}`;
};
export const getCurrentDateYYYYMMDD = () => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = (now.getMonth() + 1).toString().padStart(2, "0");
  const currentDay = now.getDate().toString().padStart(2, "0");
  return `${currentYear}-${currentMonth}-${currentDay}`;
};
